import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppContext } from '../../../context/AppProvider';
import { apis } from '../../../services/alm';
import LibraryCourseDetail from '../library-course-detail';
import LibrarySubSections from './LibrarySubSections';
import { constants } from '../../../assets/constants/constants';
import { getRecommendedContent } from '../../../services/ai';
import PageLoader from '../../common/loader/PageLoader';
type OtherSectionType = {
  librarySectionsIds: any;
  addBookMark?: any;
  deleteBookMark?: any;
  bookMarkresponse?:any
};
const LibrarySubSectionsContainer = ({
  librarySectionsIds,
  addBookMark,
  deleteBookMark,
  bookMarkresponse
}: OtherSectionType) => {
  const [loading, setLoading] = useState(true);
  const [isData, setIsData] = useState<any>([]);
  const [isBookMarkClicked, setIsBookmarkClicked] = useState<any>(false);
  const [, setIsRecommendedData] = useState<any>([]);
  const {state, dispatch } = useContext(AppContext);
  const catalogDataByid = async () => {
    let obj: any = {};
    try {
      for (const property in librarySectionsIds) {
        const response: any = await apis.fetchContentByCatalogIdForLibrary(
          `${librarySectionsIds[property].id}`
        );
        const finalResult = [];
        finalResult.push(response.data);
        let isTrue = response?.links?.next;
        while (isTrue) {
          const res: any = await apis.nextBaseUrl(isTrue);
          finalResult.push(res.data);
          isTrue = res?.links?.next ? res?.links?.next : false;
        }
        obj = {
          ...obj,
          [property]: finalResult.flat(1),
        };
        setLoading(false);
      }
    } catch (error) {
      console.log('error', error);
    }
    dispatch({ type: 'LIBRARY_DATA', payload: obj });
  };
  useEffect(() => {
    catalogDataByid();
  }, [librarySectionsIds]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (state.user)
      getData()
  }, [isBookMarkClicked])
  const getData = () => {
    getRecommendedContent(state?.user?.userId).then((res: any) => {
      const arr1 = res.slice(constants.OFFSET, constants.LP_PAGE_LIMIT)
      const arr2 = res.slice(constants.LP_PAGE_LIMIT, constants.SEE_MORE_LIMITS)
      const newArr = [arr1, arr2]
      setIsData(newArr)
    })
  }
  const fetchRecommendedContent = async (courses: any) => {
    const Apiresponse = await Promise.all(courses.map(async (item: any) => {
      let result:any=[]
      if(item.length>0){
        result = await apis.getRecomendedContent(item)
      }
      return result?.data
    }))
    dispatch({
      type: "LIBRARY_DATA",
      payload: { ...state.libraryData, "Recommended": Apiresponse.flat(1).filter((res:any)=>res!==undefined) },
    });
    setIsRecommendedData(Apiresponse.flat(1).filter((res:any)=>res!==undefined))
  }
  useEffect(() => {
    if (isData.flat(1).length > 0) {
      fetchRecommendedContent(isData)
    }
  }, [bookMarkresponse, isData,isBookMarkClicked])
  

  return (
    <>
      <Routes>
        <Route
          path="/library-course/:courseId"
          element={<LibraryCourseDetail catalogDataByid={catalogDataByid} setIsBookmarkClicked={setIsBookmarkClicked} />}
        />
        <Route
          path="/"
          element={
            <>
              {loading && <PageLoader />}
              <LibrarySubSections
                librarySectionsIds={librarySectionsIds}
                addBookMark={addBookMark}
                deleteBookMark={deleteBookMark}
                loading={loading}
              />
            </>
          }
        />
      </Routes>
    </>
  );
};

export default LibrarySubSectionsContainer;
